var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-section",style:({ height: _vm.height }),attrs:{"id":_vm.sectionId}},[_c('div',{staticClass:"main-content container",attrs:{"data-scroll":"","data-scroll-sticky":"","data-scroll-target":`#${_vm.sectionId}`,"data-scroll-id":_vm.sectionId}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }